/**
 * AVPro WebGL passes `stagePlaybackUrl` into IVSStage; `participantId` in the query string
 * makes ivs.js treat only that IVS participant as the "artist" and strip other remotes' audio.
 * That id is only valid for one sharer — same-room handoff breaks unless we clear it and rely
 * on room-based gating (see TemplateData/ivs.js) + IvsScreenSharePublisher for the presenter.
 */
export function stripParticipantIdFromIvsAvProUrl(url: string): string {
  if (!url || typeof url !== 'string') {
    return url;
  }
  if (!/participantid=/i.test(url)) {
    return url;
  }
  try {
    const hasProtocol = /^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(url);
    const u = hasProtocol
      ? new URL(url)
      : new URL(url, 'https://ivs-avpro.local/');
    u.searchParams.delete('participantId');
    if (hasProtocol) {
      return u.toString();
    }
    const path = u.pathname === '/' || u.pathname === '' ? '' : u.pathname;
    return path + u.search + (u.hash || '');
  } catch {
    return url;
  }
}
